import { render, staticRenderFns } from "./MainList.vue?vue&type=template&id=2b1b00f2&"
import script from "./MainList.vue?vue&type=script&lang=js&"
export * from "./MainList.vue?vue&type=script&lang=js&"
import style0 from "./MainList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports